"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeLocalizer = exports.dateLocalizer = exports.timeSince = void 0;
var moment_1 = __importDefault(require("moment"));
var date_fns_1 = require("date-fns");
var MINUTE_IN_MILLISECONDS = 1000 * 60;
var HOUR_IN_MILLISECONDS = MINUTE_IN_MILLISECONDS * 60;
var DAY_IN_MILLISECONDS = HOUR_IN_MILLISECONDS * 24;
var timeSince = function (dateString) {
    if (!dateString)
        return '';
    var createdDate = moment_1.default.utc(dateString);
    var now = Date.now();
    var diff = now - createdDate.valueOf();
    // If the difference is less than 1 minute, return x seconds ago
    if (diff < MINUTE_IN_MILLISECONDS) {
        var seconds = Math.floor(diff / 1000);
        if (seconds === 0) {
            return "Just now";
        }
        return "".concat(seconds, " second").concat(seconds > 1 ? 's' : '', " ago");
    }
    else if (diff < HOUR_IN_MILLISECONDS) {
        var minutes = Math.floor(diff / MINUTE_IN_MILLISECONDS);
        return "".concat(minutes, " minute").concat(minutes > 1 ? 's' : '', " ago");
    }
    else if (diff < DAY_IN_MILLISECONDS) {
        var hours = Math.floor(diff / HOUR_IN_MILLISECONDS);
        return "".concat(hours, " hour").concat(hours > 1 ? 's' : '', " ago");
    }
    else {
        // shows local
        var dateString_1 = (0, moment_1.default)(createdDate).local().format('MMM D, YYYY h:mm A');
        return dateString_1;
    }
};
exports.timeSince = timeSince;
// Time Helpers
var dateLocalizer = function (time) {
    var parseTime = (0, date_fns_1.parseISO)(time);
    return (0, date_fns_1.format)(parseTime, 'P');
};
exports.dateLocalizer = dateLocalizer;
var timeLocalizer = function (time) {
    var parseTime = (0, date_fns_1.parseISO)(time);
    return (0, date_fns_1.format)(parseTime, 'p');
};
exports.timeLocalizer = timeLocalizer;
